import { INotificationItem } from "../../app/modules/core/_models";
import { StoreAction } from "../../utils/actions";

/** State type */
interface notificationState {
    notificationData: INotificationItem[] | [];
    isNotificationDataLoaded: boolean;
}

/** Action type */
interface NotificationAction {
    type: string;
    payload: INotificationItem[] | INotificationItem | number | null;
}

const initialState: notificationState = {
    notificationData: [],
    isNotificationDataLoaded: false,
};

export default function notificationReducer(
    state: notificationState = initialState,
    action: NotificationAction
): notificationState {

    switch (action.type) {

        //  Replace full list
        case StoreAction.NOTIFICATION_DATA:
            return {
                ...state,
                notificationData: action.payload as INotificationItem[],
                isNotificationDataLoaded: true
            };

        //  Add single
        case StoreAction.ADD_NOTIFICATION:
            return {
                ...state,
                notificationData: [
                    action.payload as INotificationItem,
                    ...(state.notificationData || []),
                ],
            };

        //  Delete by id
        case StoreAction.DELETE_NOTIFICATION:
            return {
                ...state,
                notificationData: (state.notificationData || []).filter(
                    (item) => item.id !== action.payload
                ),
            };

        //  Update by id
        case StoreAction.UPDATE_NOTIFICATION:
            return {
                ...state,
                notificationData: (state.notificationData || []).map((item) =>
                    item.id === (action.payload as INotificationItem).id
                        ? { ...item, ...(action.payload as INotificationItem) }
                        : item
                ),
            };

        default:
            return state;
    }
}
